<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-sys__slcustomer}">
        <!-- <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.id" placeholder="经纪人姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select  v-model="dataForm.userType" filterable clearable  placeholder="合作机构">
                    <el-option
                            v-for="item in userTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  v-model="dataForm.userType" filterable clearable  placeholder="类型">
                    <el-option
                            v-for="item in userTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
             <el-input v-model="dataForm.id" placeholder="借款人姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select  v-model="dataForm.status" filterable clearable  placeholder="进件状态">
                    <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
        </el-form> -->
        <el-table v-loading="dataListLoading" :data="dataList" border  style="width: 100%;">
          <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
          <el-table-column prop="changeTime" label="变更时间" header-align="center" align="center"></el-table-column>
          <el-table-column prop="beforeChange" label="变更前" header-align="center" align="center">
            <template slot-scope="scope">
              {{ geteducation(scope.row.beforeChange,'beforeChange') }}
            </template>
          </el-table-column>
          <el-table-column prop="afterChange" label="变更后" header-align="center" align="center">
            <template slot-scope="scope">
              {{ geteducation(scope.row.afterChange,'afterChange') }}
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" header-align="center" align="center"></el-table-column>
          <!-- <el-table-column prop="userType" min-width="200" label="类型" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.myishsow" v-model="scope.row.userType"  filterable clearable  placeholder="类型">
                    <el-option
                            v-for="item in userTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
              </el-select>
              <div v-else>{{ geteducation(scope.row.userType,'userType') }}</div>
            </template>
          </el-table-column>
          
          <el-table-column prop="userName" label="备注" min-width="200" header-align="center" align="center">
            <template slot-scope="scope">
              <el-input v-if="scope.row.myishsow" v-model="scope.row.userName" placeholder="经纪人姓名" clearable></el-input>
              <div v-else>{{ scope.row.userName }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('sys:slcustomer:update')" type="text" size="small" @click="submitStatus(scope.row)">{{ scope.row.myishsow ? '完成' : '修改' }}</el-button>
              <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">完成</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- <el-button type="" @click="$router.push('/wx-entry')">到进件管理</el-button> -->
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
//   import AddOrUpdate from './entry-add-or-update'
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/slstatechangerecord/page',
          getDataListIsPage: true,
          exportURL: '/sys/slstatechangerecord/export',
          deleteURL: '/sys/slstatechangerecord',
          deleteIsBatch: true
        },
        text:'修改',
        userTypes: [],
        statusList: [],
        dataForm: {
          status: '',
          id: '',
          userType: '',
         
        }
      }
    },
    created(){
      this.getuserTypeOptions()
      this.getentryStatusOptions()
    },
  
    methods: {
      //修改状态
      submitStatus(row){
        console.log(this.dataList.findIndex(item => item.id == row.id))
        let n = this.dataList.findIndex(item => item.id == row.id)
        this.$set(this.dataList,n,{...this.dataList[n],myishsow: !this.dataList[n].myishsow})
        if(row.myishsow){
          console.log(this.dataList)
        }
      },
      geteducation(v,name){
         return this.statusList.filter(item => item.value == v)[0]?.label ;
        // if(name == 'userType')  return this.userTypes.filter(item => item.value == v)[0]?.label ;
        // if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
        // if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
        // if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
        // if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      },
         //初始用户类型名称下拉框中的选项
         async getuserTypeOptions() {
             this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.userTypes = [];
                if (res.data!=null){
                    res.data.forEach(element => {
                        this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                    })
                }
            }).catch(() => {})
        },
        //初始进件状态下拉框中的选项
        async getentryStatusOptions() {
            this.$http.get(`/sys/dict/data/list?dataType=entryStatus`).then(({ data: res }) => {
                if (res.code !== 0) {
                    return this.$message.error(res.msg)
                }
                this.statusList=[];
                if (res.data!=null){
                    res.data.forEach(element => {
                        this.statusList.push({label:element.dictLabel,value:element.dictValue})
                    })
                }
            }).catch(() => {})
        },
    },

  }
  </script>
  